import { useContext } from 'react'
import useGetDraftQuestionnaire from '../../../hooks/questionnaire/useGetDraftQuestionnaire'
import { useHasEarlierWaves } from '../../../modules/Questionnaire/Kpi/HasEarlierWavesContext'
import {
  describeEntriesKpiImpact,
  getEntriesKpiImpact
} from '../../../modules/Questionnaire/Kpi/kpiImpact'
import QuestionnaireContext, {
  closeDeleteSectionDialog,
  setSectionEntryNumberToBeDeleted
} from '../../../modules/Questionnaire/Questionnaire.context'
import { useDeleteSection } from '../Section.hooks'
import { DraftSectionItem } from '../Section.model'
import DialogDeleteSectionComponent from './DialogDeleteSection.component'

const DialogDeleteSection = () => {
  const { questionnaireState, dispatch } = useContext(QuestionnaireContext)
  const { draftQuestionnaire } = useGetDraftQuestionnaire()
  const hasEarlierWaves = useHasEarlierWaves()

  const sectionEntry = draftQuestionnaire?.entries.find(
    (entry) => entry.number === questionnaireState.sectionEntryNumberToBeDeleted
  )

  const { deleteSectionAndQuestions, deleteSectionWithoutQuestions } =
    useDeleteSection(sectionEntry?.id ?? '')

  const handleCloseDeleteSection = () => {
    dispatch(setSectionEntryNumberToBeDeleted(-1))
    dispatch(closeDeleteSectionDialog())
  }

  if (!sectionEntry) {
    return null
  }

  const { contextPosition, entryItem } = sectionEntry
  const sectionName = `Section ${contextPosition + 1}`
  // @todo Legacy eslint violation – fix this when editing
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const sectionEntries = (entryItem as DraftSectionItem).entries ?? []
  const numberOfEntries = sectionEntries.length
  const kpiDeleteText = describeEntriesKpiImpact(
    getEntriesKpiImpact(sectionEntries),
    hasEarlierWaves,
    'Delete all also removes'
  )

  return (
    <DialogDeleteSectionComponent
      isOpened={questionnaireState.isDeleteSectionDialogOpened}
      sectionName={sectionName}
      numberOfEntries={numberOfEntries}
      kpiDeleteText={kpiDeleteText}
      onClose={handleCloseDeleteSection}
      onDeleteAll={deleteSectionAndQuestions}
      onDeleteWithoutQuestions={deleteSectionWithoutQuestions}
    />
  )
}

export default DialogDeleteSection
